<template>
  <div>
    <div class="vx-col w-full">
      <ul class="heading-ul mb-5">
        <li>
          <router-link :to="{ path: '/setup/media-pricing/details' }" class="vx-row">
            <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            <h4>{{ $t("setup.label.AddMediaDetails") }}</h4>
          </router-link>
        </li>
      </ul>
    </div>
    <ValidationObserver ref="observer">
      <div class="vx-row">
        <vx-card>
          <div class="vx-row">
            <div class="header-text">
              <h5>{{ $t("setup.label.SelectMediaCategory") }}</h5>
            </div>
            <div class="header-button ml-4">
              <vs-button
                class="ml-5"
                @click="$router.push('/add_Media').catch(() => {})"
                >{{ $t("setup.label.Movies") }}</vs-button
              >
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.MediaTitle')"
              >
                <vs-input
                  :label="$t('setup.label.MediaTitle')"
                  class="w-full mb-2 font-semibold starlabel"
                  v-model="media.mediaTitle"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold">{{
                  $t("setup.label.ContentProvider")
                }}</small>
                <v-select
                  label="mCodeValue"
                  :options="mediaTemplateData.contentProviderData"
                  v-model="media.contentProvider"
                  :reduce="(option) => option.id"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 w-full mb-2"
                >
                  <template v-slot:option="option">{{
                    option.mCodeValue
                  }}</template>
                </v-select>
              </div>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold">{{
                  $t("setup.label.MediaType")
                }}</small>
                <v-select
                  label="value"
                  :options="mediaTemplateData.mediaTypeData"
                  v-model="media.mediatype"
                  :reduce="(data) => data.id"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 w-full mb-2"
                >
                  <template v-slot:option="option">{{ option.value }}</template>
                </v-select>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <vs-input
                :label="$t('setup.label.Rated')"
                class="w-full mb-2 font-semibold"
                v-model="media.rated"
              />
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold"
                  >{{ $t("setup.label.MediaCategory")
                  }}<span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.MediaCategory')"
                >
                  <v-select
                    label="mCodeValue"
                    :options="mediaTemplateData.mediaCategeorydata"
                    v-model="media.catageoryId"
                    :reduce="(catageoryId) => catageoryId.id"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                  >
                    <template v-slot:option="option">{{
                      option.mCodeValue
                    }}</template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <vs-input
                :label="$t('setup.label.Rating')"
                class="w-full mb-2 font-semibold"
                v-model="media.mediaRating"
              />
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <vs-input
                :label="$t('setup.label.Poster')"
                class="w-full mb-2 font-semibold"
                v-model="media.mediaImage"
              />
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold"
                  >{{ $t("setup.label.Status") }}<span class="required"> *</span></small
                >
                <v-select
                  label="value"
                  :options="mediaTemplateData.mediaStatus"
                  v-model="media.status"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :reduce="(data) => data.value"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 w-full mb-2"
                >
                  <template v-slot:option="option">{{ option.value }}</template>
                </v-select>
              </div>
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <vs-input
                :label="$t('setup.label.MovieDuration')"
                class="w-full mb-2 font-semibold"
                v-model="media.duration"
              />
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label">{{ $t("setup.label.ReleaseDate") }}</small>
                <datepicker
                  :placeholder="$t('placeholder.label.SelectDate')"
                  v-model="media.releaseDate"
                  class="mb-2 font-semibold"
                />
              </div>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <vs-input
                :label="$t('setup.label.Genre')"
                class="w-full mb-2 font-semibold"
                v-model="media.genre"
              />
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <vs-input
                :label="$t('setup.label.Subject')"
                class="w-full mb-2 font-semibold"
                v-model="media.subject"
              />
            </div>
          </div>
          <div class="vx-row mt-5">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <vs-input
                :label="$t('setup.label.Overview')"
                class="w-full mb-2 font-semibold"
                v-model="media.overview"
              />
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <vs-input
                :label="$t('setup.label.Share(%)')"
                class="w-full mb-2 font-semibold"
                v-model="media.cpShareValue"
              />
            </div>
          </div>

          <div class="vx-row mt-6">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <h4>{{ $t("setup.label.MediaDetails") }}</h4>
            </div>
          </div>
          <div class="vx-row mt-4">
            <div class="vx-col w-1/8">
              <vs-input
                :label="$t('setup.label.Cast')"
                class="w-full mb-2 font-semibold"
                v-model="media.mediaassetAttributes.attributeType"
              />
            </div>

            <div class="vx-col w-1/8">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold">{{
                  $t("setup.label.AttributeType")
                }}</small>
                <v-select
                  label="mediaName"
                  :options="mediaTemplateData.mediaAttributes"
                  v-model="media.mediaassetAttributes.attributeName"
                  :reduce="(data) => data.id"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 w-full mb-2"
                >
                </v-select>
              </div>
            </div>
            <div class="vx-col w-1/8">
              <vs-input
                :label="$t('setup.label.CaptionValue')"
                class="w-full mb-2 font-semibold"
                v-model="media.mediaassetAttributes.attributevalue"
              />
            </div>
            <div class="vx-col w-1/8">
              <vs-input
                :label="$t('setup.label.NickName')"
                class="w-full mb-2 font-semibold"
                v-model="media.mediaassetAttributes.attributeNickname"
              />
            </div>
            <div class="vx-col w-1/8">
              <vs-input
                :label="$t('setup.label.Image')"
                class="w-full mb-2 font-semibold"
                v-model="media.mediaassetAttributes.attributeImage"
              />
            </div>
            <div class="vx-col mt-4" style="margin: 0.5rem 0">
              <vs-button
                @click="addParameter"
                icon-pack="feather"
                icon="icon-plus"
                title="add"
                color="success"
                svgClasses="w-5 h-5
              hover:text-primary stroke-current cursor"
              >
              </vs-button>
            </div>
          </div>
          <div class="vx-row mt-5" v-if="media.mediaassetAttributes.length > 0">
            <div class="vx-col w-100 lg:w-100 md:w-100 sm:w-100 xs:w-100">
              <!-- <div class=""> -->
              <table class="table w-full table-bordered table-striped">
                <thead>
                  <tr>
                    <th>
                      <b>{{ $t("setup.label.Cast") }}</b>
                    </th>
                    <th>
                      <b>{{ $t("setup.label.AttributeType") }}</b>
                    </th>
                    <th>
                      <b>{{ $t("setup.label.CaptionValue") }}</b>
                    </th>
                    <th>
                      <b>{{ $t("setup.label.NickName") }}</b>
                    </th>
                    <th>
                      <b>{{ $t("setup.label.Image") }}</b>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(data, index) in media.mediaassetAttributes"
                    :key="index"
                  >
                    <td>
                      <vs-input
                        class="input-body mb-2 font-semibold"
                        v-model="data.attributeType"
                      />
                    </td>
                    <td>
                      <v-select
                        label="mediaName"
                        :options="mediaTemplateData.mediaAttributes"
                        v-model="data.attributeName"
                        :placeholder="$t('placeholder.label.SelectOne')"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        class="input-body2"
                      >
                      </v-select>
                    </td>
                    <td>
                      <vs-input
                        class="input-body mb-2 font-semibold"
                        v-model="data.attributevalue"
                      />
                    </td>
                    <td>
                      <vs-input
                        class="input-body mb-2 font-semibold"
                        v-model="data.attributeNickname"
                      />
                    </td>
                    <td>
                      <vs-input
                        class="input-body mb-2 font-semibold"
                        v-model="data.attributeImage"
                      />
                    </td>
                    <td>
                      <button
                        @click="removeItem(index)"
                        class="bGNone border-none mt-5 view_editTable_btn"
                      >
                        <feather-icon
                          icon="TrashIcon"
                          :title="$t('setup.label.Delete')"
                          svgClasses="w-5 h-5 text-danger stroke-current cursor"
                          class="icon_row"
                        />
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- </div> -->
            </div>
          </div>

          <div class="vx-row mt-6">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <h4>{{ $t("setup.label.MediaLocation") }}</h4>
            </div>
          </div>
          <div class="vx-row mt-4">
            <div class="vx-col w-1/8">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold">{{
                  $t("setup.label.Language")
                }}</small>
                <v-select
                  label="mCodeValue"
                  :options="mediaTemplateData.mediaLanguageData"
                  v-model="media.mediaAssetLocations.languageId"
                  :reduce="(option) => option.id"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 w-full mb-2"
                >
                </v-select>
              </div>
            </div>
            <div class="vx-col w-1/8">
              <div class="dropdown-with-label">
                <small class="date-label font-semibold">{{
                  $t("setup.label.Format")
                }}</small>
                <v-select
                  label="mediaName"
                  :options="mediaTemplateData.mediaFormat"
                  v-model="media.mediaAssetLocations.formatType"
                  :reduce="(data) => data.mediaName"
                  :placeholder="$t('placeholder.label.SelectOne')"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 w-full mb-2"
                >
                </v-select>
              </div>
            </div>
            <div class="vx-col w-1/8">
              <vs-input
                :label="$t('setup.label.Location')"
                class="w-full mb-2 font-semibold"
                v-model="media.mediaAssetLocations.location"
              />
            </div>
            <div class="vx-col mt-4" style="margin: 0.5rem 0">
              <vs-button
                @click="addLocation"
                icon-pack="feather"
                icon="icon-plus"
                title="add"
                color="success"
                svgClasses="w-5 h-5
              hover:text-primary stroke-current cursor"
              >
              </vs-button>
            </div>
          </div>
          <div class="vx-row mt-5" v-if="media.mediaAssetLocations.length > 0">
            <div class="vx-col w-100 lg:w-100 md:w-100 sm:w-100 xs:w-100">
              <!-- <div class=""> -->
              <table class="table w-full table-bordered table-striped">
                <thead>
                  <tr>
                    <th>
                      <b>{{ $t("setup.label.Language") }}</b>
                    </th>
                    <th>
                      <b>{{ $t("setup.label.Format") }}</b>
                    </th>
                    <th>
                      <b>{{ $t("setup.label.Location") }}</b>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(data, index) in media.mediaAssetLocations"
                    :key="index"
                  >
                    <td>
                      <v-select
                        label="mCodeValue"
                        :options="mediaTemplateData.mediaLanguageData"
                        v-model="data.languageId"
                        :placeholder="$t('placeholder.label.SelectOne')"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        class="input-body2"
                      />
                    </td>
                    <td>
                      <v-select
                        label="mediaName"
                        :options="mediaTemplateData.mediaFormat"
                        v-model="data.formatType"
                        :placeholder="$t('placeholder.label.SelectOne')"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        class="input-body2"
                      >
                      </v-select>
                    </td>
                    <td>
                      <vs-input
                        class="input-body mb-2 font-semibold starlabel"
                        v-model="data.location"
                      />
                    </td>
                    <td>
                      <button
                        @click="removeLocation(index)"
                        class="bGNone border-none mt-5 view_editTable_btn"
                      >
                        <feather-icon
                          icon="TrashIcon"
                          :title="$t('setup.label.Delete')"
                          svgClasses="w-5 h-5 text-danger stroke-current cursor"
                          class="icon_row"
                        />
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- </div> -->
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-row center">
        <div class="vx-col w-full">
          <vs-button
            color="primary"
            type="border"
            class="mb-2 footerButton-cancel"
            @click="resetForm"
            >{{ $t("setup.label.Reset") }}</vs-button
          >
          <vs-button
            class="mr-3 mb-2 footerButton-next"
            @click="handleSubmit"
            >{{ $t("setup.label.Submit") }}</vs-button
          >
        </div>
      </div>
    </ValidationObserver>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import moment from "moment";
import vSelect from "vue-select";
import { mapState } from "vuex";
import Datepicker from "vuejs-datepicker";
import ValidationPopup from "@/components/ValidationPopup.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";

const mediaEmptyObj = {
  mediaTitle: "",
  contentProvider: "",
  mediatype: "",
  rated: "",
  catageoryId: "18",
  mediaRating: "",
  mediaImage: "",
  status: "ACTIVE",
  duration: "",
  releaseDate: moment().format("DD MMMM YYYY"),
  genre: "",
  subject: "",
  overview: "",
  cpShareValue: "",
  mediaassetAttributes: {
    attributeType: "",
    attributeName: "",
    attributevalue: "",
    attributeNickname: "",
    attributeImage: "",
  },
  mediaAssetLocations: {
    languageId: "",
    formatType: "",
    location: "",
  },
  dateFormat: "dd MMMM yyyy",
  locale: "en",
};

export default {
  data() {
    return {
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      media: mediaEmptyObj,
    };
  },
  components: {
    "v-select": vSelect,
    Datepicker,
    "validation-popup": ValidationPopup,
    ValidationProvider,
    ValidationObserver,
  },
  computed: {
    ...mapState({
      mediaTemplateData: (state) => state.mediaDetails.mediaTemplate,
    }),
  },
  methods: {
    removeItem(i) {
      this.media.mediaassetAttributes.splice(i, 1);
    },
    removeLocation(i) {
      this.media.mediaAssetLocations.splice(i, 1);
    },
    addParameter() {
      try {
        let createParameter = {
          attributeType: this.media.mediaassetAttributes.attributeType,
          attributeName: this.media.mediaassetAttributes.attributeName,
          attributevalue: this.media.mediaassetAttributes.attributevalue,
          attributeNickname: this.media.mediaassetAttributes.attributeNickname,
          attributeImage: this.media.mediaassetAttributes.attributeImage,
        };
        this.media.mediaassetAttributes = [
          ...this.media.mediaassetAttributes,
          createParameter,
        ];
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    addLocation() {
      try {
        let createLocation = {
          languageId: this.media.mediaAssetLocations.languageId,
          formatType: this.media.mediaAssetLocations.formatType,
          location: this.media.mediaAssetLocations.location,
        };
        this.media.mediaAssetLocations = [
          ...this.media.mediaAssetLocations,
          createLocation,
        ];
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async handleSubmit() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      this.media.locale = "en";
      this.media.dateFormat = "DD MMMM YYYY";
      this.media.mediaTypeCheck = "ADVANCEMEDIA";
      this.media.releaseDate = moment(this.media.startDate).format(
        "DD MMMM YYYY"
      );

      try {
        await this.$store.dispatch(
          "mediaDetails/createMediaElementAction",
          this.media
        );
        this.$router.push("/setup/media-pricing/details");
        // this.resetForm();
      } catch (e) {
        this.errorMessage = e.message.errors[0].defaultUserMessage.replace(
          "The parameter",
          ""
        );
        this.warningPopup = true;
        this.errors = e.message.errors;
      }
    },
    async getMediaTemplateData() {
      try {
        await this.$store.dispatch(
          "mediaDetails/getMediaElementTemplateAction"
        );
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },

    resetForm() {
      this.media = {
        mediaassetAttributes: [],
        mediaAssetLocations: [],
        status: "ACTIVE",
        releaseDate: moment().format("DD MMMM YYYY"),
      };
      this.$refs.observer.reset();
    },
    cancel() {
      this.$router.push("/setup/media-pricing/details");
    },
  },
  watch: {},
  mounted() {
    this.resetForm();
    this.getMediaTemplateData();
    this.id = this.$route.params.id;
  },
};
</script>
<style>
.card-body {
  height: 900px;
}
.input-body {
  width: 180px;
}
.input-body2 {
  width: 180px;
  margin-top: 10px;
}
.header-text {
  margin-left: 13px;
}
.header-button {
  margin-top: -10px;
}
</style>
